jQuery( function( $ ) {
	$( document ).ready( function() {

		/**
		 * Code fired on each page
		 * @author Przemysław Hernik
		 * @see https://toddmotto.com/mastering-the-module-pattern/
		 */
		initJS = ( function() {

			var

				init = function() {
					_stickyNav();
					_initializeLightbox();
					_initializeClickableDropdown();
					_initMobileMenu();
					_initSidebarFunctions();
					_initMobileFunctions();
					_initSwiper();
				},

				finalize = function() {

				},

				/**
				 * Pins nav to top on scrolling
				 *
				 * @author PH
				 */
				_stickyNav = function() {

					if ( $( window ).width() > 992 ) {
						var zero = 0,
							navHeight = $( '#main_navigation' ).height();

						$( window ).on( 'scroll', function() {
							if ( $( window ).scrollTop() > navHeight - navHeight/2 ) {
								$( '.navbar-custom' ).toggleClass( 'hidden', $( window ).scrollTop() > zero );
								zero = $( window ).scrollTop();
							}
						});

					};

				},

				/**
				 * Make dropdown parent clickable
				 * By default BS4 blocks links which are dropdown parent.
				 *
				 * @author PH
				 */
				_initializeClickableDropdown = function() {
					$( 'a.dropdown-toggle' ).click( function() {
						window.location.href = $( this ).attr( 'href' );
					});
				},

				/**
				 * Lightbox Initizlization
				 *
				 * @author PH
				 * @see http://ashleydw.github.io/lightbox/
				 */
				_initializeLightbox = function() {
					$( '[data-toggle="lightbox"]' ).click( function( e ) {
						e.preventDefault();
						$( this ).ekkoLightbox();
					});
				},

				/**
				* Mobile menu
				**/

				_initMobileMenu = function() {
					$( '#main_navigation .navbar-toggler' ).click( function( ) {
						$( this ).toggleClass( 'open' );
						$( 'body' ).toggleClass( 'dropdown-open' );
					});

					$( '#main_navigation .caret' ).click( function( ) {
						$( this ).toggleClass( 'open' );
						$( this ).parents( '.menu-item' ).find( '.dropdown-menu' ).toggleClass( 'open' ).slideToggle( 200 );
					});
				},

				/**
				* Sidebar widget functions
				**/

				_initSidebarFunctions = function() {
					$( '#manual-menu .mm__item-header a' ).click( function( ) {
						$( this ).toggleClass( 'open' );
					});
				},

				_initMobileFunctions = function() {
					$( '.tmmm__toggler' ).click( function( ) {
						$( this ).toggleClass( 'open' );
						$( this ).parent().find( '.tmmm__content' ).slideToggle( 100 );
					});

					$( '.trmm__toggler' ).click( function( ) {
						$( this ).toggleClass( 'open' );
						$( this ).parents( '.tr__content-menu' ).find( '.widget--tr-menu' ).slideToggle( 100 );
					});
				},

				_initSwiper = function() {
					var swiper = new Swiper( '.ta__testimonials .swiper-container', {
						pagination: {
							el: '.swiper-pagination'
						},
						autoplay: {
							delay: 8000
						}
					});
				}
			;

			return {
				init: init,
				finalize: finalize
			};

		}() );

	});
});
